const getRangeToday = () => {
  var d = new Date();
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);

  var d2 = new Date(d);
  d2.setDate(d2.getDate() + 1);

  return [d, d2];
};

const getRangeYesterday = () => {
  var d = new Date();
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);

  var d2 = new Date(d);
  d2.setDate(d2.getDate() - 1);

  return [d2, d];
};

const getRangeThisWeek = () => {
  var d = new Date();
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);
  var d2 = new Date(d);
  d.setDate(d.getDate() + 1);

  if (d2.getDay() == 0) {
    d2.setDate(d2.getDate() - 6);
  } else {
    d2.setDate(d2.getDate() - d2.getDay() + 1);
  }

  return [d2, d];
};

const getRangeLastWeek = () => {
  var d = new Date();
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);
  if (d.getDay() == 0) {
    d.setDate(d.getDate() - 6);
  } else {
    d.setDate(d.getDate() - d.getDay() + 1);
  }

  var d2 = new Date(d);
  d2.setDate(d2.getDate() - 7);

  return [d2, d];
};

const getRangeThisMonth = () => {
  var d = new Date();
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);
  var d2 = new Date(d);
  d.setDate(d.getDate() + 1);

  d2.setDate(1);

  return [d2, d];
};

const getRangeLastMonth = () => {
  var d = new Date();
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);
  d.setDate(1);

  var d2 = new Date(d);
  d2.setMonth(d2.getMonth() - 1);

  return [d2, d];
};

const getRangeThisYear = () => {
  var d = new Date();
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);
  var d2 = new Date(d);
  d.setDate(d.getDate() + 1);

  d2.setMonth(0);
  d2.setDate(1);

  return [d2, d];
};

const getRangeLastYear = () => {
  var d = new Date();
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);
  d.setMonth(0);
  d.setDate(1);

  var d2 = new Date(d);
  d2.setYear(d2.getFullYear() - 1);

  return [d2, d];
};

const getDateFormatList = () => {
  return [
    { value: "%y-%m-%d %H:%i:%S", label: "Нийтээр" },
    { value: "%Y%m%d", label: "Өдрөөр" },
    { value: "%Y%m", label: "Сараар" },
    { value: "%Y", label: "Жилээр" },
  ];
};

const getDateRangeList = () => {
  return [
    { value: "today", label: "Өнөөдөр" },
    { value: "yesterday", label: "Өчигдөр" },
    { value: "this week", label: "Энэ 7 хоног" },
    { value: "last week", label: "Өнгөрсөн 7 хоног" },
    { value: "this month", label: "Энэ сар" },
    { value: "last month", label: "Өнгөрсөн сар" },
    { value: "this year", label: "Энэ жил" },
    { value: "last year", label: "Өнгөрсөн жил" },
  ];
};

const getDateRangeValues = () => {
  var ranges = [];
  ranges["today"] = getRangeToday();
  ranges["yesterday"] = getRangeYesterday();
  ranges["this week"] = getRangeThisWeek();
  ranges["last week"] = getRangeLastWeek();
  ranges["this month"] = getRangeThisMonth();
  ranges["last month"] = getRangeLastMonth();
  ranges["this year"] = getRangeThisYear();
  ranges["last year"] = getRangeLastYear();
  return ranges;
};

export { getDateFormatList, getDateRangeList, getDateRangeValues };
